/* fourpaw-standard: lifecycle-delegated */
(() => {
  if (window.SafeWalkV6RealGiftEditor) return;

  const copy = () => window.SafeWalkV6RealGiftCopy || {};
  const shouldAutoFocus = () => window.matchMedia?.(
    '(min-width: 750px) and (hover: hover) and (pointer: fine)'
  ).matches;
  const validationKey = (personalization) => {
    const validator = window.SafeWalkV6RealGifts?.validationKey;
    return typeof validator === 'function' ? validator(personalization) : 'validation';
  };
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const buildEditor = (editor) => {
    if (editor.childElementCount) return;
    const fields = make('div', 'fp-cart-gift-group__editor-fields');
    [['dog', copy().dogNameLabel, editor.dataset.safewalkDogName], ['phone', copy().phoneLabel, editor.dataset.safewalkPhone]]
      .forEach(([kind, labelText, value]) => {
        const label = make('label', 'fp-cart-gift-group__field');
        label.append(make('span', '', labelText));
        const input = document.createElement('input');
        input.dataset.safewalkGiftInput = kind;
        input.value = value || '';
        input.maxLength = kind === 'dog' ? 40 : 20;
        if (kind === 'phone') {
          input.type = 'tel';
          input.inputMode = 'tel';
          input.autocomplete = 'tel';
          input.dir = 'ltr';
        }
        label.append(input);
        fields.append(label);
      });
    editor.append(fields, make('p', 'fp-cart-gift-group__helper', copy().helper));
    const actions = make('div', 'fp-cart-gift-group__editor-actions');
    const save = make('button', 'fp-cart-gift-group__save', copy().save);
    save.type = 'button';
    save.dataset.safewalkGiftSave = '';
    const cancel = make('button', 'fp-cart-gift-group__cancel', copy().cancel);
    cancel.type = 'button';
    cancel.dataset.safewalkGiftCancel = '';
    actions.append(save, cancel);
    editor.append(actions);
  };
  const editorFor = (target) => target?.closest('.fp-cart-gift-group')
    ?.querySelector('[data-safewalk-gift-editor]');
  const triggerFor = (groupId, surfaceKey = '') => {
    const surface = surfaceKey
      ? `[data-safewalk-gift-surface="${CSS.escape(surfaceKey)}"] `
      : '';
    return document.querySelector(
      `${surface}[data-safewalk-gift-edit][data-safewalk-real-gift-group="${CSS.escape(groupId)}"]`
    );
  };
  const closeEditor = (editor, restoreFocus = true) => {
    if (!editor) return;
    editor.hidden = true;
    const trigger = editor.closest('.fp-cart-gift-group')
      ?.querySelector('[data-safewalk-gift-edit]');
    trigger?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) trigger?.focus();
  };
  const setMessage = (editor, message, state = '') => {
    const group = editor?.closest('.fp-cart-gift-group');
    const node = group?.querySelector('[data-safewalk-gift-message]');
    if (node) {
      node.textContent = message || '';
      if (message && state) node.dataset.safewalkMessageState = state;
      else delete node.dataset.safewalkMessageState;
    }
    return node;
  };
  const resetEditor = (editor) => {
    if (!editor) return;
    const values = {
      dog: editor.dataset.safewalkDogName || '',
      phone: editor.dataset.safewalkPhone || ''
    };
    editor.querySelectorAll('[data-safewalk-gift-input]').forEach((input) => {
      input.value = values[input.dataset.safewalkGiftInput] || '';
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    });
    const save = editor.querySelector('[data-safewalk-gift-save]');
    if (save) {
      save.disabled = false;
      save.textContent = copy().save;
    }
    editor.removeAttribute('aria-busy');
    setMessage(editor, '');
  };
  const checkoutBlocked = () => {
    const lifecycleState = document.documentElement.dataset.safewalkGiftReconcile;
    return Boolean(document.querySelector(
      '[data-safewalk-gift-contract="invalid"]:not([data-safewalk-gift-fallback])'
    ))
      || lifecycleState === 'pending'
      || lifecycleState === 'invalid';
  };
  const recoveryNeeded = () => {
    const lifecycleState = document.documentElement.dataset.safewalkGiftReconcile;
    return Boolean(document.querySelector(
      '[data-safewalk-gift-contract="invalid"]:not([data-safewalk-gift-fallback])'
    )) || lifecycleState === 'invalid';
  };
  const buildRecovery = (surface, index) => {
    const card = make('section', 'fp-cart-gift-group fp-cart-gift-group--invalid fp-cart-gift-group--fallback');
    card.dataset.safewalkGiftContract = 'invalid';
    card.dataset.safewalkGiftFallback = '';
    const body = make('div', 'fp-cart-gift-group__contract-error');
    body.setAttribute('role', 'status');
    body.setAttribute('aria-live', 'polite');
    body.append(make('span', 'fp-cart-gift-group__error-icon', '!'));
    const content = make('span');
    const heading = make('h3', '', copy().contractErrorHeading);
    heading.id = `fp-cart-gift-fallback-${index}`;
    card.setAttribute('aria-labelledby', heading.id);
    content.append(heading, make('p', '', copy().contractError));
    const actions = make('span', 'fp-cart-gift-group__recovery');
    const retry = make('button', '', copy().retryLabel);
    retry.type = 'button';
    retry.dataset.safewalkGiftRetry = '';
    actions.append(retry);
    if (copy().whatsappUrl) {
      const link = make('a', '', copy().whatsappLabel);
      link.href = copy().whatsappUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      if (copy().whatsappIconUrl) {
        const icon = document.createElement('img');
        icon.src = copy().whatsappIconUrl;
        icon.alt = '';
        icon.width = 18;
        icon.height = 18;
        link.prepend(icon);
      }
      actions.append(link);
    }
    content.append(actions);
    body.append(content);
    card.append(body);
    const checkout = surface.querySelector('.cart__ctas');
    checkout?.parentNode?.insertBefore(card, checkout);
  };
  const syncRecovery = (invalid) => {
    document.querySelectorAll('.cart-drawer, #main-cart-footer').forEach((surface, index) => {
      const fallback = surface.querySelector('[data-safewalk-gift-fallback]');
      const rendered = surface.querySelector(
        '[data-safewalk-gift-contract="invalid"]:not([data-safewalk-gift-fallback])'
      );
      if (!invalid || rendered) {
        fallback?.remove();
        return;
      }
      if (!fallback) buildRecovery(surface, index);
    });
  };
  const syncRecoveryCopy = () => {
    const readd = document.documentElement.dataset.safewalkGiftRecovery === 'readd';
    document.querySelectorAll(
      '[data-safewalk-gift-contract="invalid"] .fp-cart-gift-group__contract-error'
    ).forEach((body) => {
      const message = body.querySelector('p');
      const retry = body.querySelector('[data-safewalk-gift-retry]');
      if (message) {
        message.dataset.safewalkRecoveryBase ||= message.textContent || '';
        const messageText = readd ? copy().readdMessage : message.dataset.safewalkRecoveryBase;
        if (message.textContent !== messageText) message.textContent = messageText;
      }
      if (retry) {
        retry.dataset.safewalkRecoveryBase ||= retry.textContent || '';
        const retryText = readd ? copy().readdLabel : retry.dataset.safewalkRecoveryBase;
        if (retry.textContent !== retryText) retry.textContent = retryText;
      }
    });
  };
  const syncMainQuantityControls = () => {
    const indexes = new Set((window.SafeWalkV6RealGiftMainIndexes || []).map(Number));
    if (window.SafeWalkV6RealGiftMainIndexesReady !== true) {
      document.querySelectorAll('[data-safewalk-main-line-index]').forEach((group) => {
        const index = Number(group.dataset.safewalkMainLineIndex || 0);
        if (index) indexes.add(index);
      });
    }
    document.querySelectorAll('quantity-input[data-safewalk-quantity-locked="true"]')
      .forEach((control) => {
        const row = control.closest('[id^="CartItem-"], [id^="CartDrawer-Item-"]');
        const index = Number(row?.id?.match(/(\d+)$/)?.[1] || 0);
        const input = control.querySelector('.quantity__input');
        if (indexes.has(index) && Number(input?.value) === 1) return;
        control.querySelectorAll('.quantity__button').forEach((button) => {
          button.disabled = button.dataset.safewalkQuantityWasDisabled === 'true';
          delete button.dataset.safewalkQuantityWasDisabled;
        });
        if (input) {
          input.readOnly = input.dataset.safewalkQuantityWasReadonly === 'true';
          if (input.dataset.safewalkQuantityMin) input.min = input.dataset.safewalkQuantityMin;
          else input.removeAttribute('min');
          if (input.dataset.safewalkQuantityMax) input.max = input.dataset.safewalkQuantityMax;
          else input.removeAttribute('max');
          delete input.dataset.safewalkQuantityWasReadonly;
          delete input.dataset.safewalkQuantityMin;
          delete input.dataset.safewalkQuantityMax;
        }
        delete control.dataset.safewalkQuantityLocked;
      });
    indexes.forEach((index) => {
      document.querySelectorAll(`#CartItem-${index} quantity-input, #CartDrawer-Item-${index} quantity-input`)
        .forEach((control) => {
          const input = control.querySelector('.quantity__input');
          if (!input || Number(input.value) !== 1) return;
          if (control.dataset.safewalkQuantityLocked === 'true') return;
          control.dataset.safewalkQuantityLocked = 'true';
          control.querySelectorAll('.quantity__button').forEach((button) => {
            button.dataset.safewalkQuantityWasDisabled = String(Boolean(button.disabled));
            button.disabled = true;
          });
          input.dataset.safewalkQuantityWasReadonly = String(Boolean(input.readOnly));
          input.dataset.safewalkQuantityMin = input.getAttribute('min') || '';
          input.dataset.safewalkQuantityMax = input.getAttribute('max') || '';
          input.min = '1';
          input.max = '1';
          input.readOnly = true;
      });
    });
  };
  const syncAcceleratedCheckout = () => {
    document.querySelectorAll(
      '.cart-drawer .cart__dynamic-checkout-buttons, .cart-drawer .additional-checkout-buttons, '
      + '#main-cart-footer .cart__dynamic-checkout-buttons, #main-cart-footer .additional-checkout-buttons'
    ).forEach((node) => {
      node.hidden = true;
      node.inert = true;
      node.setAttribute('aria-hidden', 'true');
    });
  };
  const syncCheckoutState = () => {
    const invalid = checkoutBlocked();
    syncAcceleratedCheckout();
    syncMainQuantityControls();
    syncRecovery(recoveryNeeded());
    syncRecoveryCopy();
    document.querySelectorAll('button[name="checkout"], input[name="checkout"], [data-safewalk-checkout]')
      .forEach((button) => {
        if (invalid && button.dataset.safewalkGiftCheckoutLock !== 'true') {
          button.dataset.safewalkGiftCheckoutLock = 'true';
          button.dataset.safewalkGiftCheckoutWasDisabled = String(Boolean(button.disabled));
          button.dataset.safewalkGiftCheckoutAriaPresent = String(button.hasAttribute('aria-disabled'));
          button.dataset.safewalkGiftCheckoutAriaValue = button.getAttribute('aria-disabled') || '';
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          return;
        }
        if (invalid || button.dataset.safewalkGiftCheckoutLock !== 'true') return;
        button.disabled = button.dataset.safewalkGiftCheckoutWasDisabled === 'true';
        if (button.dataset.safewalkGiftCheckoutAriaPresent === 'true') {
          button.setAttribute('aria-disabled', button.dataset.safewalkGiftCheckoutAriaValue);
        } else {
          button.removeAttribute('aria-disabled');
        }
        delete button.dataset.safewalkGiftCheckoutLock;
        delete button.dataset.safewalkGiftCheckoutWasDisabled;
        delete button.dataset.safewalkGiftCheckoutAriaPresent;
        delete button.dataset.safewalkGiftCheckoutAriaValue;
      });
  };
  document.addEventListener('click', async (event) => {
    const retry = event.target.closest?.('[data-safewalk-gift-retry]');
    if (retry) {
      const canReadd = document.documentElement.dataset.safewalkGiftRecovery === 'readd';
      const recover = window.SafeWalkV6RealGiftLifecycle?.recoverLegacyCart;
      if (canReadd && typeof recover === 'function') {
        retry.disabled = true;
        const result = await recover();
        if (result?.ok && result.readdUrl) {
          window.location.assign(result.readdUrl);
          return;
        }
        retry.disabled = false;
      }
      window.location.reload();
      return;
    }
    const edit = event.target.closest?.('[data-safewalk-gift-edit]');
    if (edit) {
      const editor = editorFor(edit);
      if (!editor) return;
      document.querySelectorAll('[data-safewalk-gift-editor]:not([hidden])')
        .forEach((open) => closeEditor(open, false));
      buildEditor(editor);
      resetEditor(editor);
      editor.hidden = false;
      edit.setAttribute('aria-expanded', 'true');
      if (shouldAutoFocus()) editor.querySelector('input')?.focus();
      return;
    }
    const cancel = event.target.closest?.('[data-safewalk-gift-cancel]');
    if (cancel) {
      const editor = editorFor(cancel);
      resetEditor(editor);
      closeEditor(editor);
      return;
    }
    const save = event.target.closest?.('[data-safewalk-gift-save]');
    if (!save) return;
    const editor = editorFor(save);
    const personalization = {
      dogName: editor?.querySelector('[data-safewalk-gift-input="dog"]')?.value || '',
      phone: editor?.querySelector('[data-safewalk-gift-input="phone"]')?.value || ''
    };
    const errorKey = validationKey(personalization);
    if (!editor || errorKey) {
      const message = setMessage(editor, copy()[errorKey] || copy().validation, 'error');
      const dogNameMissing = !String(personalization.dogName || '').trim();
      const invalidInput = errorKey === 'phoneError'
        ? editor?.querySelector('[data-safewalk-gift-input="phone"]')
        : editor?.querySelector(dogNameMissing ? '[data-safewalk-gift-input="dog"]' : '[data-safewalk-gift-input="phone"]');
      invalidInput?.setAttribute('aria-invalid', 'true');
      if (message?.id) invalidInput?.setAttribute('aria-describedby', message.id);
      invalidInput?.focus();
      return;
    }
    save.disabled = true;
    save.textContent = copy().saving;
    editor.setAttribute('aria-busy', 'true');
    try {
      const groupId = editor.dataset.safewalkRealGiftGroup;
      const surfaceKey = editor.closest('.fp-cart-gift-group')?.dataset.safewalkGiftSurface || '';
      await window.SafeWalkV6RealGifts.updateTag({ groupId, personalization });
      const fresh = triggerFor(groupId, surfaceKey);
      fresh?.focus();
      const message = fresh?.closest('.fp-cart-gift-group')
        ?.querySelector('[data-safewalk-gift-message]');
      if (message) {
        message.textContent = copy().success;
        message.dataset.safewalkMessageState = 'success';
      }
    } catch (error) {
      save.disabled = false;
      save.textContent = copy().save;
      editor.removeAttribute('aria-busy');
      setMessage(editor, copy().networkError, 'error');
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeEditor(event.target.closest?.('[data-safewalk-gift-editor]'));
  });
  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('[data-safewalk-gift-input]');
    if (!input) return;
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
    setMessage(editorFor(input), '');
  });
  document.addEventListener('submit', (event) => {
    const checkoutForm = event.target?.matches?.('#cart, #CartDrawer-Form')
      || event.submitter?.name === 'checkout';
    if (!checkoutForm || !checkoutBlocked()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    syncCheckoutState();
  }, true);
  document.addEventListener('safewalk:real-gifts-rendered', syncCheckoutState);
  document.addEventListener('safewalk:real-gifts-state', syncCheckoutState);
  const observer = new MutationObserver(syncCheckoutState);
  const boot = () => {
    observer.observe(document.body, { childList: true, subtree: true });
    syncCheckoutState();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.SafeWalkV6RealGiftEditor = Object.freeze({ validationKey, syncCheckoutState });
})();
